import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Funding } from "../../../domain/contracts/Funding";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

  function buildFundingQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }
  return `
    SELECT
      p.Funding.Code                  AS Code,
      p.Funding.Name                  AS Name,
      p.Funding.Payer                 AS Payer,
      p.Funding.Percentage            AS Percentage,
      p.Funding.FederalParticipation  AS FederalParticipation
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
  }

export async function queryFundingForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Funding | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildFundingQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;   // { Code, Name, Payer, Percentage, FederalParticipation }
    const funding = Funding.fromObject(plain);
    return funding;
  }

  // No Funding struct attached to that element
  return undefined;
}
